var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectSettingFin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 160,
    viewBox: "0 0 656 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_8735)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 656,
    height: 160,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 36.5H151.5C170.83 36.5 186.5 52.17 186.5 71.5V88.3936C186.5 105.297 200.203 119 217.106 119H354.5C375.21 119 392 102.211 392 81.5V81.5C392 60.7893 375.21 44 354.5 44H318C297.289 44 280.5 60.7893 280.5 81.5V81.5C280.5 102.211 297.289 119 318 119H456.759C459.532 119 462.25 118.231 464.611 116.778L480.5 107",
    stroke: "#1271FF",
    strokeWidth: 19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 102,
    width: 11,
    height: 34,
    fill: "#2A80FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246,
    y: 102,
    width: 11,
    height: 34,
    fill: "#2A80FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417,
    y: 102,
    width: 11,
    height: 34,
    fill: "#2A80FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429,
    y: 102,
    width: 11,
    height: 34,
    fill: "#2A80FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 29,
    width: 11,
    height: 30,
    fill: "#2A80FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 22,
    width: 11,
    height: 30,
    fill: "#2A80FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 72,
    width: 11,
    height: 30,
    transform: "rotate(90 201 72)",
    fill: "#2A80FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.563,
    cy: 39.9087,
    r: 32.0913,
    fill: "#FFA455"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5637,
    cy: 39.9094,
    r: 23.0832,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1648 7.80879C20.1285 11.8451 20.1285 18.3893 24.1648 22.4256L38.7816 7.80879C34.7453 3.77247 28.2012 3.77247 24.1648 7.80879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8322 7.80683C93.8685 11.8432 93.8685 18.3873 89.8322 22.4236L75.2154 7.80683C79.2517 3.77052 85.7959 3.77052 89.8322 7.80683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 28.1899C54 26.4287 55.4277 25.001 57.189 25.001C58.9502 25.001 60.3779 26.4287 60.3779 28.1899V41.812C60.3779 43.5732 58.9502 45.001 57.189 45.001C55.4277 45.001 54 43.5732 54 41.812V28.1899Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8977 51.3225C63.1192 52.544 65.0996 52.544 66.321 51.3225C67.5425 50.101 67.5425 48.1206 66.321 46.8992L59.3567 39.9348C58.1352 38.7133 56.1548 38.7133 54.9333 39.9348C53.7119 41.1563 53.7119 43.1367 54.9334 44.3582L61.8977 51.3225Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 16.8262,
    width: 2.25202,
    height: 3.37803,
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 59.6143,
    width: 2.25202,
    height: 3.37803,
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 16.8262,
    width: 2.25202,
    height: 3.37803,
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 59.6152,
    width: 2.25202,
    height: 3.37803,
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.2686,
    y: 41.5977,
    width: 2.25202,
    height: 3.37803,
    transform: "rotate(-90 77.2686 41.5977)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.4805,
    y: 41.5977,
    width: 2.25202,
    height: 3.37803,
    transform: "rotate(-90 34.4805 41.5977)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.5,
    cy: 70.5,
    r: 70.5,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.83 118.425C630.126 118.696 630.462 118.92 630.827 119.091C631.305 119.315 631.823 119.442 632.351 119.464C632.879 119.485 633.405 119.402 633.9 119.218L633.403 117.879L633.9 119.218C634.395 119.034 634.848 118.754 635.234 118.394L634.261 117.349L635.234 118.394C635.621 118.034 635.932 117.602 636.152 117.122C636.372 116.643 636.496 116.125 636.517 115.597C636.539 115.07 636.458 114.544 636.278 114.048C636.099 113.552 635.824 113.096 635.469 112.705C635.469 112.705 635.469 112.705 635.469 112.705L631.596 108.448L637.591 102.863L637.593 102.862C637.978 102.502 638.289 102.069 638.508 101.59C638.727 101.11 638.85 100.592 638.871 100.065C638.892 99.5381 638.81 99.012 638.629 98.5165C638.449 98.0219 638.174 97.567 637.819 97.1782C637.464 96.7878 637.036 96.471 636.559 96.2468C636.08 96.0221 635.562 95.8951 635.033 95.8733C634.505 95.8516 633.978 95.9356 633.483 96.1201C632.987 96.3046 632.534 96.5858 632.148 96.9466C632.148 96.9467 632.148 96.9467 632.148 96.9468L626.185 102.503L621.749 97.6284L627.744 92.0439L627.744 92.0437C628.524 91.3173 628.983 90.311 629.027 89.2473C629.071 88.1836 628.696 87.1429 627.978 86.3549C627.261 85.5663 626.259 85.0955 625.192 85.0516C624.126 85.0077 623.089 85.3945 622.309 86.1214L616.338 91.6837L612.487 87.4571C612.487 87.4569 612.487 87.4568 612.487 87.4566C612.132 87.0665 611.703 86.7501 611.225 86.5262L610.619 87.8199L611.225 86.5262C610.747 86.3022 610.229 86.1755 609.701 86.1538C608.635 86.1099 607.598 86.4967 606.818 87.2237C606.038 87.9501 605.579 88.9563 605.535 90.0201C605.496 90.9684 605.79 91.8984 606.362 92.6474L596.212 102.111C596.212 102.111 596.212 102.111 596.212 102.111C595.164 103.088 594.316 104.263 593.718 105.569C593.119 106.875 592.781 108.286 592.722 109.723C592.663 111.16 592.884 112.594 593.373 113.945C593.862 115.296 594.61 116.537 595.575 117.596C595.575 117.596 595.575 117.596 595.575 117.596L597.267 119.455L587.984 128.105C587.598 128.464 587.287 128.897 587.067 129.376C586.847 129.856 586.723 130.374 586.701 130.901C586.68 131.428 586.761 131.955 586.94 132.451C587.12 132.947 587.395 133.403 587.75 133.794C588.468 134.582 589.469 135.053 590.536 135.097C591.064 135.119 591.59 135.035 592.085 134.851C592.58 134.667 593.033 134.387 593.42 134.027L602.678 125.4L604.347 127.235C604.347 127.235 604.347 127.235 604.347 127.235C605.312 128.295 606.474 129.153 607.768 129.759C609.063 130.365 610.464 130.708 611.891 130.767C613.317 130.825 614.742 130.599 616.082 130.101C617.422 129.603 618.651 128.844 619.699 127.867L619.699 127.867L629.83 118.425ZM610.24 121.781L610.24 121.781L601.472 112.147L601.472 112.147C601.217 111.867 601.018 111.538 600.888 111.178C600.758 110.819 600.698 110.436 600.714 110.052C600.73 109.668 600.82 109.292 600.98 108.944C601.139 108.596 601.364 108.285 601.641 108.027C601.641 108.027 601.641 108.027 601.641 108.027L611.764 98.5999L624.407 112.491L614.266 121.947C614.265 121.947 614.265 121.947 614.265 121.947C613.989 122.205 613.665 122.405 613.314 122.535C612.963 122.666 612.591 122.725 612.218 122.709C611.846 122.694 611.479 122.605 611.14 122.446C610.801 122.287 610.495 122.061 610.24 121.781Z",
    fill: "#D6DCE4",
    stroke: "#D6DCE4",
    strokeWidth: 2.85714
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.269 53.9475C489.799 54.4658 493.052 58.5587 492.534 63.0894L490.802 78.2307C491.878 82.2862 492.849 87.9482 492.207 89.9156C491.267 92.7938 486.45 103.116 484.159 107.918L458.682 105.03C456.177 98.6629 451.596 85.2731 453.321 82.6512C454.436 80.9545 464.443 77.8051 474.452 75.8531L476.127 61.2127C476.645 56.682 480.738 53.4293 485.269 53.9475Z",
    fill: "#FFD8D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.264 106.654L453.267 103.208L449.956 140.111L448.883 152.076C447.97 162.249 455.477 171.236 465.651 172.149C475.8 173.059 484.773 165.59 485.718 155.444L490.264 106.654Z",
    fill: "#00388D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 162C488 132.177 512.177 108 542 108H552C581.823 108 606 132.177 606 162H488Z",
    fill: "#00388D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.949 7.95482C495.111 12.6637 500.675 23.553 511.377 32.2769L525.277 15.2246C514.575 6.50079 502.788 3.24598 498.949 7.95482Z",
    fill: "#1271FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.999 67.4287C591.999 93.3861 570.957 114.429 544.999 114.429C519.042 114.429 501.999 93.3861 501.999 67.4287C501.999 41.4713 519.042 20.4287 544.999 20.4287C570.957 20.4287 591.999 41.4713 591.999 67.4287Z",
    fill: "#FFD8D5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 583.999,
    cy: 67.4277,
    r: 22,
    fill: "#FFD8D5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 509.919,
    cy: 68.3487,
    r: 3.92,
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 541.278,
    cy: 68.3487,
    r: 3.92,
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.499 46.4293C504.299 47.6293 497.499 42.2627 495.999 39.4293C494.876 37.9293 497.499 36.9292 501.499 35.4292C505.499 33.9292 512.857 13.9292 543.999 13.9287C576.999 13.9282 590.666 38.0954 596.499 49.4287C586.499 47.8287 583.999 62.596 582.999 70.9293C583.499 51.9293 573.999 44.9293 561.499 40.9293C548.999 36.9293 538.499 44.9293 519.499 46.4293Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.328 8.64306C551.387 2.0819 532.45 6.75379 517.786 19.212L597.999 50.4277C595.551 31.342 585.268 15.2042 568.328 8.64306Z",
    fill: "#1271FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 521.999,
    cy: 76.9287,
    rx: 3,
    ry: 2.5,
    fill: "#DDA4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 86V86C520.362 88.5458 526.554 88.6929 532.032 86.4046L533 86",
    stroke: "#C6918A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538 108H554V118C554 122.418 550.418 126 546 126C541.582 126 538 122.418 538 118V108Z",
    fill: "#FFD8D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 104,
    width: 30,
    height: 56,
    rx: 14,
    transform: "rotate(90 322 104)",
    fill: "#418DFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 108,
    width: 76,
    height: 23,
    fill: "url(#paint0_linear_140_8735)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 104,
    width: 11,
    height: 30,
    fill: "#2A80FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.5,
    cy: 118.5,
    r: 4.5,
    fill: "#0046B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.5,
    cy: 118.5,
    r: 4.5,
    fill: "#0046B0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 120,
    width: 5,
    height: 5,
    fill: "#D06100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 125H309V139.5C309 141.433 307.433 143 305.5 143C303.567 143 302 141.433 302 139.5V125Z",
    fill: "#FF963A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.5,
    cy: 118.5,
    r: 3.5,
    fill: "#0051CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_140_8735",
    x1: 385.5,
    y1: 108,
    x2: 385.5,
    y2: 131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#88B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E3EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_8735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 656,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectSettingFin);
export default __webpack_public_path__ + "static/media/connect_setting_fin.9afcd7a987992adca2d9339133849b8e.svg";
export { ForwardRef as ReactComponent };